import React, { useEffect } from 'react';
import { setUserPermissions } from 'src/store/apps/permissions/PermissionsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useGetUserPermissionsMutation } from 'src/services/users';
import { Box, CircularProgress } from '@mui/material';
import { AppState } from 'src/store/Store';

const PermessionHandler = ({ children }: { children: React.ReactNode }) => {
  const [getUserPermissions, { isLoading: isLoadingPermissions }] = useGetUserPermissionsMutation();

  const user = useSelector((state: AppState) => state.authReducer.user);

  const dispatch = useDispatch();

  const getPermissions = () => {
    getUserPermissions({}).then((result: any) => {
      if (result.data?.data?.permissions) {
        dispatch(setUserPermissions(result?.data?.data?.permissions || []));
      }
    });
  };

  useEffect(() => {
    if (user?.token) {
      getPermissions();
    }
  }, [user?.token]);

  if (isLoadingPermissions) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        flexDirection="column"
        gap={2}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return <>{children}</>;
};

export default PermessionHandler;
